import { Typography } from 'components/atoms';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import React from 'react';
import { Link } from 'react-router-dom';
import './index.scss';

export interface AttendanceTrackingCrumb {
  label: string;
  to?: string;
}

interface Props {
  title: string;
  description?: string;
  descriptionSingleLine?: boolean;
  subDescription?: string;
  crumbs?: AttendanceTrackingCrumb[];
  titleLeading?: React.ReactNode;
  titleAction?: React.ReactNode;
  action?: React.ReactNode;
}

export const AttendanceTrackingPageHeader = ({
  title,
  description,
  descriptionSingleLine,
  subDescription,
  crumbs,
  titleLeading,
  titleAction,
  action
}: Props) => {
  const trail = crumbs ?? [
    { label: 'Attendance Tracking', to: '/attendance-tracking' },
    { label: title }
  ];

  return (
    <header className="attendance-tracking-page-header">
      <nav className="attendance-tracking-page-header__breadcrumbs" aria-label="Breadcrumb">
        {trail.map((crumb, index) => {
          const isLast = index === trail.length - 1;

          return (
            <React.Fragment key={`${crumb.label}-${index}`}>
              {crumb.to && !isLast ? (
                <Link to={crumb.to} className="attendance-tracking-page-header__crumb">
                  {crumb.label}
                </Link>
              ) : (
                <span
                  className={`attendance-tracking-page-header__crumb ${
                    isLast ? 'attendance-tracking-page-header__crumb--current' : ''
                  }`}
                >
                  {crumb.label}
                </span>
              )}
              {!isLast && (
                <KeyboardArrowRightIcon
                  className="attendance-tracking-page-header__separator"
                  fontSize="small"
                />
              )}
            </React.Fragment>
          );
        })}
      </nav>

      <div className="attendance-tracking-page-header__row">
        <div className="attendance-tracking-page-header__main">
          {titleAction || titleLeading ? (
            <div className="attendance-tracking-page-header__title-row">
              <div className="attendance-tracking-page-header__title-group">
                {titleLeading}
                <Typography type="heading2" text={title} weight="bold" />
              </div>
              {titleAction}
            </div>
          ) : (
            <Typography type="heading2" text={title} weight="bold" />
          )}
          {(description || subDescription) && (
            <div className="attendance-tracking-page-header__description-row">
              {description && (
                <Typography
                  type="base_medium"
                  text={description}
                  className={`attendance-tracking-page-header__description${
                    descriptionSingleLine
                      ? ' attendance-tracking-page-header__description--single-line'
                      : ''
                  }`}
                />
              )}
              {subDescription && (
                <Typography
                  type="small_regular"
                  text={subDescription}
                  className="attendance-tracking-page-header__sub-description"
                />
              )}
            </div>
          )}
        </div>
        {action && (
          <div className="attendance-tracking-page-header__action">{action}</div>
        )}
      </div>
    </header>
  );
};
